import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import classnames from 'classnames';
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import ExcelExportButton from '../../common/excelExportButton';

class RecievablesData extends React.Component {
    state = {
        historyDebtExpanded: false,
        historyClosedGroupsExpanded: false
    };
    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        const actualDebt = isNullOrUndefined(data.debt) ? null : data.debt.filter(f => !f.isHistorical);
        const historicalDebt = isNullOrUndefined(data.debt) ? null : data.debt.filter(f => f.isHistorical);
        const actualClosedGroups = isNullOrUndefined(data.closedGroupsDebt) ? null : data.closedGroupsDebt.filter(f => !f.isHistorical);
        const historicalClosedGroups = isNullOrUndefined(data.closedGroupsDebt) ? null : data.closedGroupsDebt.filter(f => f.isHistorical);
        return (
            <div>
                <OldStyleSection
                    key={"ClosedGroups"} name={this.props.translate(`Report.Recievables.ClosedGroups`)} hasData={!isNullOrUndefined(data.closedGroupsDebt) && data.closedGroupsDebt.length > 0} isBold isOpen
                >
                    <div style={{ paddingTop: ".25em" }}>
                        {(!isNullOrUndefined(data.closedGroupsDebt) && data.closedGroupsDebt.length > 0) && <OldStyleTableWithHistory id={"table-ClosedGroups"} offsetLeft={true}
                            tableColumns={9} stripped
                            onHistoryToggle={this.onHistoryClosedGroupsToggle}
                            head={() => this.renderHeaderClosedGroups(false)}
                            historyHead={() => this.renderHeaderClosedGroupsRow(true)}
                            actualData={actualClosedGroups}
                            actualRow={(r) => this.renderDataClosedGroupsRow(r, false)}
                            historyData={historicalClosedGroups} historyRow={(r) => this.renderDataClosedGroupsRow(r, true)}
                            resolveExpanded={this.props.resolveExpanded}
                        />}
                    </div>
                </OldStyleSection>
                <OldStyleSection
                    key={"CollectionAgencies"} name={this.props.translate(`Report.Recievables.CollectionAgencies`)} hasData={!isNullOrUndefined(data.debt) && data.debt.length > 0} isBold isOpen
                >
                    <div style={{ paddingTop: ".25em", marginBottom: "1.5em" }}>
                        {(!isNullOrUndefined(data.debt) && data.debt.length > 0) && <OldStyleTableWithHistory id={"table-CollectionAgencies"} fixed={false} offsetLeft={true}
                            tableColumns={9} stripped
                            onHistoryToggle={this.onHistoryDebtToggle}
                            head={() => this.renderHeaderDebtRow()}
                            actualData={actualDebt}
                            actualRow={(r) => this.renderDataDebtRow(r, false)}
                            historyData={historicalDebt} historyRow={(r) => this.renderDataDebtRow(r, true)}
                            resolveExpanded={this.props.resolveExpanded}
                        />}
                    </div>
                </OldStyleSection>
                <ExcelExportButton link="recievables" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    onHistoryDebtToggle = (historyDebtExpanded) => {
        this.setState({ historyDebtExpanded })
    }
    onHistoryClosedGroupsToggle = (historyClosedGroupsExpanded) => {
        this.setState({ historyClosedGroupsExpanded })
    }

    renderHeaderClosedGroups = (isHistory) => {
        return (
            <thead>
                {this.renderHeaderClosedGroupsRow(isHistory)}
            </thead>
        );
    }

    renderHeaderClosedGroupsRow = (isHistory) => {
        return (
            <>
            <tr>
                <th rowSpan="2"><Translate id="Report.Recievables.ClosedGroups.Own" /></th>
                <th rowSpan="2"><Translate id="Report.Recievables.ClosedGroups.Currency" /></th>
                <th rowSpan="2" style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.SumPrice" /></th>
                <th rowSpan="2" style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.SumPriceOverdue" /></th>
                <th colSpan={4} style={{ textAlign: "center" }}><Translate id="Report.Recievables.ClosedGroups.Overdue" /></th>
                <th rowSpan="2" style={{ textAlign: "right" }}><Translate id={`Report.Recievables.ClosedGroups.DataDate.${isHistory ? "Historical" : "Actual"}`} /></th>
            </tr>
            <tr>
                        <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.To30" /></th>
                        <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.To60" /></th>
                        <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.To90" /></th>
                        <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.ClosedGroups.To120" /></th>
            </tr>
            </>
        );
    }
    renderDataClosedGroupsRow = (r, isHistory) => {
        return (
            <tr className={classnames('colorize', { 'old-style-table-report-history-row': isHistory })}>
                <td><Translate id={`Report.Recievables.ClosedGroups.Own.${r.own ? "1" : "0"}`} /></td>
                <td>{r.currency}</td>
                <td style={{ textAlign: "right" }}>{r.sumPrice}</td>
                <td style={{ textAlign: "right" }}>{r.sumPriceOverdue}</td>
                <td style={{ textAlign: "right" }}>{r.to30}</td>
                <td style={{ textAlign: "right" }}>{r.to60}</td>
                <td style={{ textAlign: "right" }}>{r.to90}</td>
                <td style={{ textAlign: "right" }}>{r.to120}</td>
                <td style={{ textAlign: "right" }}>{r.dataDateFormatted}</td>
            </tr>
        );
    }

    renderHeaderDebtRow = (data) => {
        return (
            <thead>
                <tr>
                    <th><Translate id="Report.Recievables.CollectionAgencies.Source" /></th>
                    <th><Translate id="Report.Recievables.CollectionAgencies.InoviceNumber" /></th>
                    <th><Translate id="Report.Recievables.CollectionAgencies.Currency" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.CollectionAgencies.InvoiceValue" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.CollectionAgencies.DueDate" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.CollectionAgencies.DebtValue" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.CollectionAgencies.StartDate" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Recievables.CollectionAgencies.PriceRest" /></th>
                    <th><Translate id="Report.Recievables.CollectionAgencies.Note" /></th>
                </tr>
            </thead>
        );
    }
    renderDataDebtRow = (r, isHistory) => {
        return (
            <tr className={classnames('colorize', { 'old-style-table-report-history-row': isHistory })}>
                <td>{r.source}</td>
                <td>{r.invoiceNumber}</td>
                <td>{r.currency}</td>
                <td style={{ textAlign: "right" }}>{r.invoiceValue}</td>
                <td style={{ textAlign: "right" }}>{r.dueDateFormatted}</td>
                <td style={{ textAlign: "right" }}>{r.debtValue}</td>
                <td style={{ textAlign: "right" }}>{r.startDateFormatted}</td>
                <td style={{ textAlign: "right" }}>{r.priceRest}</td>
                <td>{r.note}</td>
            </tr>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RecievablesData));
